import { newApi } from './api'

type FileInsurance = {
  categoryId: string
  insuranceId: string
  locationId: string
  category: string
  carrier: {
    name: string
    logoUrl: string
  }
}

export type LocationFile = {
  id: string
  name: string
  displayName: string
  createdAt: string
  category: string | null
  policyNumber: string
  insurance: FileInsurance
  servedAt: string | null
}

export type Location = {
  locationName: string
  files: LocationFile[]
}

export const categories = [
  'contract',
  'offer',
  'application',
  'invoice',
  'incident',
  'claim',
] as const

export type DocumentCategory = typeof categories[number]

export type Filters = {
  documentCategories: DocumentCategory[]
  insuranceCategories: string[]
  date: { from: string | undefined; to: string | undefined }
}

export const getDocuments = (
  companyId: string,
  searchQuery: string,
  filters: Filters,
) =>
  newApi.get(`/file/company/${companyId}`, {
    params: {
      searchQuery,
      ...(filters?.documentCategories?.length > 0 && {
        documentCategories: filters.documentCategories.join(','),
      }),
      ...(filters?.insuranceCategories?.length > 0 && {
        insuranceCategories: filters.insuranceCategories.join(','),
      }),
      ...(filters?.date?.from && { dateFrom: filters.date.from }),
      ...(filters?.date?.to && { dateTo: filters.date.to }),
    },
  })

export const getPresignedDownloadUrl = (companyId: string, fileId: string) =>
  newApi.get(`/file/company/${companyId}/presigned-download-url`, {
    params: { fileId },
  })

export const getPresignedPreviewUrl = (companyId: string, fileId: string) =>
  newApi.get(`/file/company/${companyId}/presigned-download-url`, {
    params: { disposition: 'inline', fileId },
  })
